import { jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../utils/classnames.js';
function Badge({ children, className, suffix, variant = 'gray', dataTestId, }) {
    return (_jsxs("div", { className: cn('ui-flex ui-h-6 ui-flex-row ui-items-center ui-justify-center ui-gap-x-0.5 ui-rounded-full ui-px-2 ui-font-mono ui-text-xs ui-font-medium', variant === 'gray' &&
            'ui-bg-gray-200 ui-text-gray-500 theme-dark:ui-bg-neutral-600 theme-dark:ui-text-white', variant === 'green' &&
            'ui-bg-green-400 ui-text-green-600 theme-dark:ui-bg-green-700 theme-dark:ui-text-green-500', variant === 'red' &&
            'ui-bg-red-400 ui-text-red-600 theme-dark:ui-bg-red-700 theme-dark:ui-text-red-500', variant === 'yellow' &&
            'ui-bg-yellow-400 ui-text-yellow-600 theme-dark:ui-bg-yellow-700 theme-dark:ui-text-yellow-500', className), "data-testid": dataTestId, children: [children, suffix] }));
}
export default Badge;
